import React from 'react';
import { Building2, Globe, Target, Users } from 'lucide-react';

export const AboutSection = () => {
  const features = [
    {
      icon: <Building2 className="text-[#10B981]" size={32} />,
      title: 'Early-Stage Fintech',
      description: 'A young team building modern payment solutions from the ground up'
    },
    {
      icon: <Target className="text-[#10B981]" size={32} />,
      title: 'Smart POS Focus',
      description: 'Android-based terminals paired with thoughtful merchant experience'
    },
    {
      icon: <Globe className="text-[#10B981]" size={32} />,
      title: 'Regional Roots',
      description: 'Operating from Austria and Jordan, with a long-term regional outlook'
    },
    {
      icon: <Users className="text-[#10B981]" size={32} />,
      title: 'Merchant-Centric',
      description: 'Designing every detail around the day-to-day needs of merchants'
    }
  ];

  return (
    <section id="about" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            About <span className="gradient-text">Syrveo</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            An early-stage fintech startup focused on smart card acceptance — building modern POS experiences for merchants across Europe and the Middle East.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="card-hover bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl border border-gray-200 shadow-sm"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Mission Statement */}
        <div className="mt-16 bg-gradient-to-r from-[#1E3A8A]/5 to-[#10B981]/5 p-12 rounded-3xl border border-[#1E3A8A]/10">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Our Mission
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              We want to make modern payment technology genuinely accessible to small and medium businesses. Our focus is on getting the fundamentals right — clean hardware, a smooth onboarding journey, and reliable support — so merchants can simply get paid and get back to running their business.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
